<template>
  <div @click.stop="() => false">
    <vs-dropdown class="cursor-pointer ml-3" vs-custom-content>
      <div class="p-3 cursor-pointer">
        <span class="mr-2 leading-none"><vs-icon style="font-size: 25px" icon-pack="material-icons"
            icon="reorder" /></span>
      </div>

      <vs-dropdown-menu>
        <vs-dropdown-item @click.stop="isDisabledItems ? null : $root.$emit(action.action, params.data)"
          v-for="(action, index) in contextMenus" :key="index">
          <span class="flex items-center">
            <span>{{ action.name }}</span>
          </span>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  name: "CellRendererApActions",
  watch: {
    "$store.state.isDisabledAllFields"(val) {
      this.toggleIsDisabledItems(val);
    },
  },
  methods: {
    toggleIsDisabledItems(val) {
      this.isDisabledItems = val;
    },
  },
  mounted() {
    this.isDisabledItems = this.$store.state.isDisabledAllFields;
  },
  data() {
    return {
      contextMenus: [
        { name: "Enable", action: "enableTask" },
        { name: "Disable", action: "disableTask" },
        { name: "Delete", action: "deleteRecordTask" },
      ],
      isDisabledItems: false,
    };
  },
};
</script>
